const PRODUCT_LANDING_TITLE_KEYS: Record<string, string> = {
  "/hotels": "common.hotel",
  "/ve-may-bay": "common.flight",
  "/tours": "common.tour",
  "/esim-du-lich": "common.esim",
}

export const normalizeAppPath = (pathname: string) =>
  pathname.replace(/^\/(en|vi)(?=\/|$)/, "") || "/"

export const getProductLandingTitleKey = (pathname: string) => {
  return PRODUCT_LANDING_TITLE_KEYS[normalizeAppPath(pathname)]
}
